var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none",
    viewBox: "0 0 12 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#28b2ab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "M1.169 7.585a.583.583 0 0 1-.455-.951L6.489.684a.292.292 0 0 1 .501.268L5.87 4.464a.583.583 0 0 0 .549.788h4.083a.583.583 0 0 1 .455.95l-5.775 5.95a.292.292 0 0 1-.502-.268L5.8 8.372a.583.583 0 0 0-.548-.787z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderIcon);
export default __webpack_public_path__ + "static/media/thunder_icon.6dc7e28b.svg";
export { ForwardRef as ReactComponent };